import { render, staticRenderFns } from "./IndexTab2.vue?vue&type=template&id=65c8c849&scoped=true&"
import script from "./IndexTab2.vue?vue&type=script&lang=js&"
export * from "./IndexTab2.vue?vue&type=script&lang=js&"
import style0 from "./IndexTab2.vue?vue&type=style&index=0&id=65c8c849&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8c849",
  null
  
)

export default component.exports